module.exports = __webpack_public_path__ + "img/PRI.1acef76d.svg";